/*
 * OrderDashboard.tsx : Un simple appel à OrderVersionDashboard selon la derniere version disponible pour cette commande.
 */

// Imports React
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import OrderVersionDashboard from './OrderVersionDashboard';

// Import Commandes
import { OrderData, OrderVersionData } from '../types/types';
import { ordersApi } from '../services/ordersApi';

// OrderDashboard page component
const OrderDashboard: React.FC = () => {
	// Hook de Navigation et Paramètres de navigation
	const navigate = useNavigate();
	const { id } = useParams<{ id: string }>();

	// Une fois le composant monté et si un id est présent, fetch du taux de taxe et préremplissage du formulaire
	React.useEffect(() => {
		// Vérification du token d'authentification
		const token = localStorage.getItem('token');
		if (!token) return;
		// Si un id est présent, on fetch la commande
		if (id) {
			ordersApi
				.get(Number(id), token)
				.then((data: OrderData) => {
					if (!data.orderVersions || data.orderVersions.length === 0) return;

					const getLatest = (versions: OrderVersionData[]) =>
						versions.reduce((prev, current) =>
							prev.versionIndex > current.versionIndex ? prev : current
						);

					const activeVersions = data.orderVersions.filter(
						(v) => v.status !== 'CANCELED'
					);

					const latestVersion =
						activeVersions.length > 0
							? getLatest(activeVersions)
							: getLatest(data.orderVersions);

					navigate(`/app/orderVersions/${latestVersion.id}/manage`);
				})
				.catch((error) => {
					console.error('Erreur lors du chargement de la commande :', error);
				});
		}
	}, [id, navigate]);

	// Render the order dashboard
	return <OrderVersionDashboard />;
};

export default OrderDashboard;
